<template>
    <div>
        <mdb-row>
            <mdb-col col="1">
                <skyscrapper-banner></skyscrapper-banner>
            </mdb-col>
            <mdb-col class="text-center">

                <mdb-row>
                    <mdb-col>
                        <standard-banner></standard-banner><br />
                    </mdb-col>
                    <mdb-col>
                        <standard-banner></standard-banner><br />
                    </mdb-col>
                </mdb-row>
                <br />
                <br />

                <mdb-datatable v-bind:data="data" class="w-75" striped bordered />
                <br />

            </mdb-col>
            <mdb-col col="1">
                <skyscrapper-banner></skyscrapper-banner>
            </mdb-col>
            <mdb-col col="1"></mdb-col>


        </mdb-row>

        <mdb-row>
            <mdb-col>
                <standard-banner></standard-banner><br />
                <standard-banner></standard-banner><br />
                <standard-banner></standard-banner><br />
            </mdb-col>
            <mdb-col>
                <standard-banner></standard-banner><br />
                <standard-banner></standard-banner><br />
                <standard-banner></standard-banner><br />
            </mdb-col>
        </mdb-row>

        <button type="button" class="bottomLeftButton" id="bottomLeftButton" onClick="document.getElementById('bottomLeftBanner').remove();this.remove();">x</button>
        <div class="bottomLeftBanner" id="bottomLeftBanner"><square-banner></square-banner></div>

        <button type="button" class="bottomRightButton" id="bottomRightButton" onClick="document.getElementById('bottomRightBanner').remove();this.remove();">x</button>
        <div class="bottomRightBanner" id="bottomRightBanner"><square-banner></square-banner></div>

    </div>
</template>

<script>
    import { mdbRow, mdbCol, Btn, mdbDatatable } from 'mdbvue';

    export default {
        components: { mdbRow, mdbCol, Btn, mdbDatatable },
        data() {
            return {
                recaptchav2SiteKey: this.$store.state.recaptchav2SiteKey,
                recaptchav3SiteKey: this.$store.state.recaptchav3SiteKey,
                errorList: null,
                successList: null,
                reference: null,
                subject: null,
                message: null,
                data: {
                    columns: [
                        {
                            label: 'Withdrawal Type',
                            field: 'WithdrawalType',
                            sort: 'asc'
                        },
                        {
                            label: 'Requested Date',
                            field: 'RequestedDate',
                            sort: 'asc'
                        },
                        {
                            label: 'Amount',
                            field: 'RequestedAmount',
                            sort: 'asc'
                        },
                        {
                            label: 'Status',
                            field: 'Status',
                            sort: 'asc'
                        },
                        {
                            label: 'Wallet',
                            field: 'Wallet',
                            sort: 'asc'
                        },
                        {
                            label: 'Address',
                            field: 'Address',
                            sort: 'asc'
                        },
                        {
                            label: 'Admin Comment',
                            field: 'Remarks',
                            sort: 'asc'
                        }
                    ],
                    rows: [

                    ]
                },
                
                
                
                
                
                
                
                
                
                
                
                
            }
        },
        sockets: {

        },
        methods: {
            test: function () {
            }

        },
        mounted() {

            this.$store.commit('isLoading', true);
            this.data.rows.length = 0;
            var data = this.$store.state.withdrawalHistory;

            for (var i = 0; i < Object.keys(data).length; i++) {

                var status = "Pending";
                if (data[i].Paid === true) {
                    status = "Approved";
                }
                else if (data[i].Paid === false) {
                    status = "Rejected";
                }
                else {
                    status = "Pending";
                }

                this.data.rows.push({
                    WithdrawalType: data[i].WithdrawalType,
                    RequestedDate: this.moment(data[i].RequestedDate).format('YYYY-MM-DD - hh:mm:ss A'),
                    RequestedAmount: data[i].RequestedAmount.toFixed(8),
                    Status: status,
                    Wallet: data[i].WalletType,
                    Address: data[i].WalletAddress,
                    Remarks: data[i].Remarks
                });

            }

            
            
            
            
            
            
            
            

            
            

            
            

            this.$store.commit('isLoading', false);
        }
    }


</script>